import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { globalTheme } from "./chakraTheme/globalTheme";
import "./globalStyle.css";
import RequireAuth from "./middleware/RequireAuth";
import AllCourses from "./pages/AllCourses";
import Landing from "./pages/Landing";
import MissingPage from "./pages/MissingPage";
import MyCourses from "./pages/MyCourses";
import MycourseWatch from "./pages/MycourseWatch";
import Register from "./pages/Register";
import ResetPassword from "./pages/ResetPassword";
import ResetPasswordInput from "./pages/ResetPasswordInput";
import UserActivationFailed from "./pages/UserActivationFailed";
import UserActivationSuccess from "./pages/UserActivationSuccess";
import VerifyCertificate from "./pages/VerifyCertificate";
import VerifyEmail from "./pages/VerifyEmail";
import DetailCourse from "./pages/DetailCourse";

export const App = () => (
  <ChakraProvider theme={globalTheme}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />

        <Route path="/register" element={<Register />} />

        <Route path="/verify-email" element={<VerifyEmail />} />

        <Route path="/allcourses" element={<AllCourses />} />

        <Route path="/allcourses/:courseId" element={<DetailCourse />} />

        <Route
          path="/mycourses"
          element={
            <RequireAuth>
              <MyCourses />
            </RequireAuth>
          }
        />

        {/* <Route
          path="/mycertificates"
          element={
            <RequireAuth>
              <MyCertificates />
            </RequireAuth>
          }
        /> */}

        <Route
          path="/mycourse/:course_id"
          element={
            <RequireAuth>
              <MycourseWatch />
            </RequireAuth>
          }
        />

        <Route
          path="/useractivationsuccess"
          element={<UserActivationSuccess />}
        />

        <Route
          path="/useractivationfailed"
          element={<UserActivationFailed />}
        />

        <Route path="/resetPassword" element={<ResetPassword />} />

        <Route
          path="/resetPassword/input/:resetpasswordticket"
          element={<ResetPasswordInput />}
        />

        <Route
          path="/verify-certificate/:publicId"
          element={<VerifyCertificate />}
        />

        <Route path="*" element={<MissingPage />} />
      </Routes>
    </BrowserRouter>
  </ChakraProvider>
);
